export default "__VITE_ASSET__DqDFB7ft__"